var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 3.09144C15.2608 2.39283 13.6763 2 12 2C6.20101 2 1.5 6.70101 1.5 12.5C1.5 18.299 6.20101 23 12 23C17.799 23 22.5 18.299 22.5 12.5C22.5 12.1057 22.4783 11.7163 22.4359 11.3333M22.5 4.33333L17.25 9.58333L12 14.8333L8.5 11.3333",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerSuccess);
export default __webpack_public_path__ + "static/media/SpinnerSuccess.53386e4b6365b2a631b01517d9eea872.svg";
export { ForwardRef as ReactComponent };